import React from "react";

const PersonalInfo = () => {
  return (
    <div
      className="flex flex-col items-start text-gray"
      style={{
        color: "gray",
        maxWidth: "500px",
        textAlign: "justify",
        margin: 0,
      }}
    >
      {/* Contact Details */}
      <div style={{fontSize:18}}>
      <div className="flex w-full justify-between mb-[10px]" style={{marginBottom:"18px"}}>
        <span className="font-semibold w-1/3 text-2xl ">CONTACT DETAILS: </span>
        <span className="w-2/3 text-left ml-auto">9689896355</span>
      </div>

      {/* Connect on Mail */}
      <div className="flex w-full justify-between mb-[18px]" style={{marginBottom:"18px"}}>
        <span className="font-semibold w-1/3 text-left">CONECT ON MAIL: </span>
        <span className="w-2/3 text-left ml-auto">hello@victortycineworld.com</span>
      </div>

      {/* Office Location */}
      <div className="flex w-full justify-between mb-[18px]" style={{marginBottom:"18px"}}>
        <span className="font-semibold w-1/3 text-left">OFFICE LOCATION: </span>
        <span className="w-2/3 text-left ml-auto">Chh. SAMBHAJINAGAR | MUMBAI</span>
      </div>

      {/* Services */}
      <div className="flex w-full justify-between mb-[18px]" style={{marginBottom:"18px"}}>
        <span className="font-semibold w-1/3 text-left">SERVICES: </span>
        <span className="w-2/3 text-left ml-auto">
          VIDEO PRODUCTION , CONTENT CREATION , <br /> SOCIAL and DIGITAL MARKETING, and IT SERVICES .
        </span>
      </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
